import { ColorSchemeTypes } from "../../types/ColorScheme"
import CardUseCases, { NormalizedCardUseCasesData, RawCardUseCasesData } from "../molecules/CardUseCases"

type RawBentoBoxCaseProps = {
  id: number
  type: string
  sectionId: string
  withBackground: boolean
  colorScheme: ColorSchemeTypes
  items: RawBentoBoxCaseItem[]
}

export interface RawBentoBoxCaseItem {
  id: number
  colorScheme: ColorSchemeTypes
  case: RawCardUseCasesData
}

export interface NormalizedBentoBoxCaseProps {
  sectionId: string
  colorScheme: ColorSchemeTypes
  withBackground: boolean
  items: NormalizedCardUseCasesData[]
}

const BentoBoxCase = ({
  sectionId,
  colorScheme,
  withBackground,
  items = [],
  ...rest
}: RawBentoBoxCaseProps): NormalizedBentoBoxCaseProps => {
  const itemsByType = items.length > 0 
    ? items.map((item) => {
      const normalizedCase = CardUseCases(item.case)
      normalizedCase.colorScheme = item.colorScheme
      
      return normalizedCase
    })
    : []

  const normalizedData = {
    sectionId,
    colorScheme,
    withBackground,
    items: itemsByType,
    ...rest
  }

  return normalizedData
}

export default BentoBoxCase

